<template>
  <v-app id="app">
    <NavBar @drawerChanged="drawer = !drawer" @didTapSearch="dialog = true"/>
    <Drawer :showDrawer="drawer" @drawerChanged="updateDrawer"/>
    <SearchDialog :showDialog="dialog" @didCloseDialog="dialog = false"/>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view :key="$route.path" />
      </v-fade-transition>
    </v-content>
  </v-app>
</template>

<script>
import NavBar from './components/navigation/NavBar.vue';
import Drawer from './components/navigation/Drawer.vue';
import SearchDialog from './components/navigation/SearchDialog.vue';

export default {
  components: {
    NavBar, Drawer, SearchDialog,
  },
  props: {
    source: String,
  },
  methods: {
    didTapItem() {

    },
    updateDrawer(value) {
      this.drawer = value;
    },
  },
  data: () => ({
    drawer: false,
    dialog: false,
  }),
};
</script>

<style>
.v-application a {
    color: #24b3ae;
}
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #24b3ae;
  background-color: var(--v-background-base);
}
</style>
